import { gql } from "@apollo/client";

// Query: Get a specific workflow design ticket
export const GET_WORKFLOW_DESIGN_TICKET_QUERY = gql`
  query GetInitialDesignLayoutTicket($ticketId: String!, $tenantId: String!) {
    getInitialDesignLayoutTicket(ticketId: $ticketId, tenantId: $tenantId) {
      ticketId
      tenantId
      status
      workflowTitle
      summaryNarrative
      priority
      source
      sourceScreen
      createdAt
      updatedAt
      completedAt
      executionArn
      designId
      workflowEntityId
      metadata
    }
  }
`;

// Query: List workflow design tickets
export const LIST_WORKFLOW_DESIGN_TICKETS_QUERY = gql`
  query ListInitialDesignLayoutTickets(
    $tenantId: String!
    $status: String
    $limit: Int
  ) {
    listInitialDesignLayoutTickets(
      tenantId: $tenantId
      status: $status
      limit: $limit
    ) {
      ticketId
      tenantId
      status
      workflowTitle
      summaryNarrative
      priority
      source
      sourceScreen
      createdAt
      updatedAt
      completedAt
      executionArn
      designId
      workflowEntityId
      metadata
    }
  }
`;

// Mutation: Create initial design layout
export const CREATE_WORKFLOW_DESIGN_MUTATION = gql`
  mutation CreateInitialDesignLayout($input: CreateInitialDesignLayoutInput!) {
    createInitialDesignLayout(input: $input) {
      ticketId
      tenantId
      status
      workflowTitle
      summaryNarrative
      priority
      source
      sourceScreen
      createdAt
      updatedAt
      completedAt
      executionArn
      designId
      workflowEntityId
      metadata
    }
  }
`;

// Subscription: Subscribe to workflow design ticket updates
export const ON_WORKFLOW_DESIGN_TICKET_UPDATE_SUBSCRIPTION = gql`
  subscription OnWorkflowDesignTicketUpdate(
    $ticketId: String!
    $tenantId: String!
  ) {
    onWorkflowDesignTicketUpdate(ticketId: $ticketId, tenantId: $tenantId) {
      ticketId
      tenantId
      status
      workflowTitle
      summaryNarrative
      priority
      source
      sourceScreen
      createdAt
      updatedAt
      completedAt
      executionArn
      designId
      workflowEntityId
      metadata
    }
  }
`;

// Subscription: Subscribe to workflow design completion
export const ON_WORKFLOW_DESIGN_COMPLETION_SUBSCRIPTION = gql`
  subscription OnWorkflowDesignCompletion($tenantId: String!) {
    onWorkflowDesignCompletion(tenantId: $tenantId) {
      ticketId
      tenantId
      status
      workflowTitle
      summaryNarrative
      priority
      source
      sourceScreen
      createdAt
      updatedAt
      completedAt
      executionArn
      designId
      workflowEntityId
      metadata
    }
  }
`;

// Aliases for backward compatibility
export const CREATE_INITIAL_DESIGN_LAYOUT_MUTATION =
  CREATE_WORKFLOW_DESIGN_MUTATION;
export const GET_INITIAL_DESIGN_LAYOUT_TICKET_QUERY =
  GET_WORKFLOW_DESIGN_TICKET_QUERY;
export const LIST_INITIAL_DESIGN_LAYOUT_TICKETS_QUERY =
  LIST_WORKFLOW_DESIGN_TICKETS_QUERY;
